import { Duration, Instant } from "@js-joda/core";
import ClinicalProtocolType from "./ClinicalProtocolType";

export type ClinicalNote = {
  id: string;
  dateTime: Instant;
  patientId: string;
  type: ClinicalProtocolType;
  actionType: ClinicalNoteActionType;
  creatorName: string;
  timeSpent: Duration;
  notes: string;
  livePatientInteraction: boolean;
};

export type CreateClinicalNote = {
  type: ClinicalProtocolType;
  timeSpent: Duration;
  notes: string;
  actionType: ClinicalNoteActionType;
  livePatientInteraction: boolean;
  assignToCaregiverId: string | null;
  sendNotifications: boolean;
};

export type ClinicalNoteActionType = "review" | "note";

export type ClinicalNoteApiDto = {
  id: string;
  dateTime: string;
  patientId: string;
  creatorName: string;
  type: ClinicalProtocolType;
  actionType: ClinicalNoteActionType;
  timeSpentInSeconds: number;
  notes: string;
  livePatientInteraction: boolean;
  assignToCaregiverId?: string;
};

export type CreateClinicalNoteApiDto = {
  type: ClinicalProtocolType;
  sendNotifications: boolean;
  actionType: ClinicalNoteActionType;
  timeSpentInSeconds: number;
  notes: string;
  livePatientInteraction: boolean;
  assignToCaregiverId: string | null;
};

export const toClinicalNote = (dto: ClinicalNoteApiDto): ClinicalNote => ({
  ...dto,
  dateTime: Instant.parse(dto.dateTime),
  timeSpent: Duration.ofSeconds(dto.timeSpentInSeconds),
});

export const toCreateClinicalNoteApiDto = (
  clinicalNote: CreateClinicalNote
): CreateClinicalNoteApiDto => ({
  ...clinicalNote,
  timeSpentInSeconds: clinicalNote.timeSpent.seconds(),
});
